export default __webpack_public_path__ + "static/media/logo.a4e3cdd2.png";